// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.isAuthenticated = true;
      state.usertype = action.payload.usertype;
      state.userid = action.payload.userid;
      state.value = action.payload.value;
      state.name = action.payload.name;

    localStorage.setItem('token', JSON.stringify({
      usertype:action.payload.usertype, // "admin" or "van"
      userid: action.payload.userid,
      value: action.payload.value,
      name:action.payload.name
    }));
    },
    logout: (state) => {
      localStorage.removeItem('token');
      return { ...initialState };
    },
  },
});

export const { setAuth, logout } = authSlice.actions;
export default authSlice.reducer;
